var AutocompleteType = {
  STREET: {},
  DIVISION: {},
  DISTRICT: {},
  POSTCODE: {},
  REGION: {},
  SCHOOL: {},
  ADDRESS: {},
  DEVELOPMENT: {},
  AGENCY: {},
  AGENT: {}
};
Object.keys(AutocompleteType).forEach(key => {
  AutocompleteType[key].name = key;
});

// Pseudo type for recent searches
export var RECENT = '_RECENT';
export var AutocompleteTypeNames = Object.keys(AutocompleteType);
export default AutocompleteType;